import {Component} from '@angular/core';

/**
 * This component is used in the components where to get data from BE
 */

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {}
